import { useSplitClient } from '@splitsoftware/splitio-react';
import { getRealmName } from 'src/routes/AuthContext';

type Treatment = string;
type Source = 'FACILITY' | 'ENTERPRISE';

const facilityId = localStorage.getItem('facilityId') || '';

function useFeatureToggle(treatment: Treatment, source: Source) {
  //  By default client is based on facility -> without splitKey
  const { client } = useSplitClient();
  
  const facilityClient = useSplitClient({ splitKey: facilityId });
  const enterpriseClient = useSplitClient({ splitKey: getRealmName()?.toLowerCase() || '' });

  const getTreatmentValue = () => {
    switch (source) {
      case 'FACILITY':
        return facilityClient.client?.getTreatment(treatment) === 'on';
      case 'ENTERPRISE':
        return enterpriseClient.client?.getTreatment(treatment) === 'on';
      default:
        return client?.getTreatment(treatment) === 'on';
    }
  };

  return [getTreatmentValue()];
}

export function useFeatureToggleWhenReady(treatment: Treatment, source: Source) {
  //  By default client is based on facility -> without splitKey
  const { client, isReady } = useSplitClient();
  const facilityClient = useSplitClient({ splitKey: facilityId });
  const enterpriseClient = useSplitClient({ splitKey: getRealmName()?.toLowerCase() || '' });
  
  
  

  const getTreatmentValue = () => {
    if(!isReady) {
      return null;
    }
    
    switch (source) {
      case 'FACILITY':
        return facilityClient.client?.getTreatment(treatment) === 'on';
      case 'ENTERPRISE':
        return enterpriseClient.client?.getTreatment(treatment) === 'on';
      default:
        return client?.getTreatment(treatment) === 'on';
    }
  };

  return [getTreatmentValue()];
}

export default useFeatureToggle;
